import { Box, Button, TextField, styled } from "@mui/material";

const Wrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  padding: "40px 0px",
  display: "flex",
  flexDirection: "column",
  gap: "24px",

  margin: "0 auto",
}));

const VerticalSeparator = styled(Box)(({ theme }) => ({
  display: "none",

  width: "1.5px",
  height: "488px",
  backgroundColor: "rgba(255, 255, 255, 0.16)",

  [theme.breakpoints.up("lg")]: {
    display: "flex",
    margin: "0 48px 0 24px",
  },
}));

const WhiteTextField = styled(TextField)({
  height: "44px",
  "& .MuiInputBase-root": {
    height: "44px",
  },
  "& fieldset": {
    height: "44px",
  },
  "& input": {
    height: "44px",
  },
  "& label": {
    color: "#6C6D70", // Color de la etiqueta
  },
  "& label.Mui-focused": {
    color: "#fff", // Color de la etiqueta al enfocar
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#fff", // Color del subrayado al enfocar
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#fff", // Fondo blanco
    color: "#6C6D70", // Color del texto ingresado
    "& fieldset": {
      borderColor: "#fff", // Color del borde
    },
    "&:hover fieldset": {
      borderColor: "#fff", // Color del borde al pasar el mouse
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff", // Color del borde al enfocar
    },
  },
  "& .MuiOutlinedInput-input": {
    color: "#6C6D70", // Color del texto ingresado
  },
  "& .MuiPlaceholder": {
    color: "#6C6D70", // Color del placeholder (no siempre necesario)
  },
  "& .MuiInput-underline:before": {
    borderBottomColor: "#6C6D70", // Color del subrayado antes del enfoque
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
    borderBottomColor: "#6C6D70", // Color del subrayado al pasar el mouse (si está usando la variante 'standard')
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#6C6D70", // Color del placeholder
    opacity: 1, // Se asegura de que el placeholder tenga la opacidad completa
  },
});

const AppStoreButton = styled(Button)(() => ({
  border: "1px solid #FFF !important",
  padding: "0px 16px !important",
  borderRadius: "8px !important",

  textAlign: "left",

  gap: "8px",
  display: "flex",
  alignItems: "center",
  flexDirection: "row",

  height: "54px !important",
}));

export { Wrapper, VerticalSeparator, WhiteTextField, AppStoreButton };
